const getAssessmentState = state => state.assessment

export const selectors = {  
  getQuestions: state => getAssessmentState(state)?.currentAssessment?.questions || [],
  getTotalQuestions: state => getAssessmentState(state)?.currentAssessment?.questions?.total_questions || 0,
  getLoading: state => getAssessmentState(state)?.loading || false,
  getError: state => getAssessmentState(state)?.error || null,
  getResponses: state => getAssessmentState(state)?.currentAssessment?.responses || {},
  getCurrentAssessmentId: state => getAssessmentState(state)?.currentAssessment?.assessment_id || '',
  getCurrentAssessmentSetId: state => getAssessmentState(state)?.currentAssessment?.assessment_set_id || '',
  getCurrentAssessment: state => getAssessmentState(state)?.currentAssessment || {},
  getCurrentBehaviorId: state => {
    const questions = getAssessmentState(state)?.currentAssessment?.questions || {}
    const responses = getAssessmentState(state)?.currentAssessment?.responses || {}
    
    // Handle behavior assessment questions
    if (questions.behaviors && Array.isArray(questions.behaviors)) {
      const currentBehavior = questions.behaviors.find(behavior => !responses[behavior.id])
      return currentBehavior ? currentBehavior.id : questions.behaviors[0]?.id || ''
    }
    
    // Handle communication assessment questions
    if (questions.communications && Array.isArray(questions.communications)) {
      return '' // Communication questions don't use behavior IDs
    }
    
    return ''
  },
  getActiveAssessments: state =>
    getAssessmentState(state)?.activeAssessments?.data || [],
  getActiveAssessmentsLoading: state =>
    getAssessmentState(state)?.activeAssessments?.loading || false,
  getActiveAssessmentsError: state =>
    getAssessmentState(state)?.activeAssessments?.error || null,
  getCompletedAssessments: state =>
    getAssessmentState(state)?.completedAssessments?.data || [],
  getCompletedAssessmentsLoading: state =>
    getAssessmentState(state)?.completedAssessments?.loading || false,
  getCompletedAssessmentsError: state =>
    getAssessmentState(state)?.completedAssessments?.error || null,
  getActiveAssessmentsFilters: state =>
    getAssessmentState(state)?.activeAssessmentsFilters || {
      duration: '',
      assessmentType: '',
      search: '',
    },
  getCompletedAssessmentsFilters: state =>
    getAssessmentState(state)?.completedAssessmentsFilters || {
      timeFilter: '',
      assessmentType: '',
      search: '',
    },
  // Reports selectors
  getReports: state => getAssessmentState(state)?.reports?.data || [],
  getReportsLoading: state => getAssessmentState(state)?.reports?.loading || false,
  getReportsError: state => getAssessmentState(state)?.reports?.error || null,
}

export default selectors
